/**
 * AUTO-GENERATED by agent-contracts-runtime. DO NOT EDIT.
 *
 * Regenerate via: npx agent-runtime generate
 */

export interface AgentRule {
  readonly id: string;
  readonly description: string;
  readonly severity: "mandatory" | "recommended" | "optional";
}

export interface EscalationCriterion {
  readonly condition: string;
  readonly action: "stop_and_report" | "report_to_architect" | "wait_for_approval";
}

export interface AgentContract {
  readonly id: string;
  readonly role_name: string;
  readonly purpose: string;
  readonly mode: "read-write" | "read-only";
  readonly dispatch_only: boolean;
  readonly can_read_artifacts: readonly string[];
  readonly can_write_artifacts: readonly string[];
  readonly can_execute_tools: readonly string[];
  readonly can_invoke_agents: readonly string[];
  readonly can_return_handoffs: readonly string[];
  readonly responsibilities: readonly string[];
  readonly constraints: readonly string[];
  readonly rules: readonly AgentRule[];
  readonly escalation_criteria: readonly EscalationCriterion[];
}

export const litedbmodelAuditor: AgentContract = {
  id: "litedbmodel-auditor",
  role_name: "litedbmodel Audit Analyst",
  purpose: "Audits TypeScript source code that uses the litedbmodel ORM to detect common anti-patterns that cause data-integrity problems, performance degradation, or correctness bugs. Reads project files using file tools to find all litedbmodel usage sites.\nThe eight canonical anti-patterns to detect:\n  (1) LOOP_CREATE — Model.create() inside a loop; use createMany instead.\n  (2) DELETE_REINSERT — full delete then re-insert; use upsert instead.\n  (3) MISSING_IDEMPOTENCY — bare create() that throws on duplicate rows.\n  (4) AGGREGATE_SKIP — inserting un-aggregated data that needs group-by first.\n  (5) OVER_DELETE — delete with overly broad conditions.\n  (6) MISSING_LOCK — concurrent-write path without forUpdate: true.\n  (7) UNIQUE_MISSING — onConflict used without a DB UNIQUE constraint.\n  (8) N_PLUS_ONE — find/findOne called inside a loop.\n\nlitedbmodel API reference (for remediation guidance):\n  Model.create(cols, opts?) — opts: { returning, onConflict, onConflictIgnore, onConflictUpdate }\n  Model.createMany(rows, opts?) — batch INSERT with same opts.\n  Model.find(conds, opts?) — opts: { order, limit, offset, forUpdate }\n  Model.findOne(conds, opts?) — single-row SELECT.\n  Model.findById(pkeyResult) — find by PkeyResult object.\n  Model.update(conds, vals, opts?) — UPDATE matching rows.\n  Model.updateMany(rows, opts?) — bulk UPDATE; opts: { keyColumns }\n  Model.delete(conds, opts?) — DELETE matching rows.\n  DBModel.transaction(fn, opts?) — opts: { retryOnError, retryLimit }\n  SKIP — exclude a condition or column dynamically.\n  sql tagged template — operator-based conditions.\n  forUpdate: true — SELECT FOR UPDATE (must be inside a transaction).\n  onConflict + onConflictUpdate — upsert (target column must have UNIQUE/PK).\n  onConflict + onConflictIgnore — insert-or-ignore.\n\nProduces structured findings (AgentAuditResult shape) with severity, category, location, message, and actionable remediation referencing the correct litedbmodel API.",
  mode: "read-only",
  dispatch_only: false,
  can_read_artifacts: [],
  can_write_artifacts: [],
  can_execute_tools: [],
  can_invoke_agents: [],
  can_return_handoffs: [
  "litedbmodel-audit-result"
],
  responsibilities: [
  "Read project source files using file tools to find all litedbmodel model import sites and usage.",
  "Classify each usage occurrence against the eight anti-pattern categories.",
  "Assign severity — info/warning/error/critical — based on data-integrity and performance impact.",
  "Provide specific remediation guidance referencing the correct litedbmodel API.",
  "Compute an overall riskLevel reflecting the most severe finding.",
  "Return a findings array even when it is empty (no issues found)."
],
  constraints: [
  "Do not suggest API methods that are not part of the documented litedbmodel interface.",
  "Do not mutate, write, or propose direct file changes; only produce findings.",
  "Stop and escalate if the source exceeds 200 KB or contains no litedbmodel import statements."
],
  rules: [
  {
    "id": "R-AUDIT-001",
    "description": "Always recommend Model.createMany() as the replacement for any loop body that contains a Model.create() call.",
    "severity": "mandatory"
  },
  {
    "id": "R-AUDIT-002",
    "description": "When a delete-then-reinsert pattern is detected, recommend Model.createMany() with onConflict + onConflictUpdate as the idiomatic upsert replacement.",
    "severity": "mandatory"
  },
  {
    "id": "R-AUDIT-003",
    "description": "Whenever onConflict / onConflictUpdate is recommended, note that the target column(s) must carry a UNIQUE or PRIMARY KEY constraint in the database schema.",
    "severity": "mandatory"
  },
  {
    "id": "R-AUDIT-004",
    "description": "N+1 findings must include the batch alternative: find() with an IN-equivalent condition, createMany(), or updateMany().",
    "severity": "mandatory"
  },
  {
    "id": "R-AUDIT-005",
    "description": "Race-condition findings in concurrent-write paths must recommend findOne/find with forUpdate: true inside DBModel.transaction().",
    "severity": "mandatory"
  }
],
  escalation_criteria: [
  {
    "condition": "The provided source code exceeds 200 KB in total size.",
    "action": "stop_and_report"
  },
  {
    "condition": "The provided source code contains no litedbmodel import statements and cannot be meaningfully audited.",
    "action": "stop_and_report"
  }
],
} as const;

export const litedbmodelImplementer: AgentContract = {
  id: "litedbmodel-implementer",
  role_name: "litedbmodel Implementation Engineer",
  purpose: "Implements litedbmodel DBModel-based business logic directly in the user's project by reading model definitions and SQL schema from the filesystem, then writing TypeScript source files. Proactively applies all litedbmodel best-practice patterns from the start: Model.createMany() for batch inserts, onConflict+onConflictUpdate for idempotent upserts, forUpdate: true for concurrent-safe reads, and DBModel.transaction() for multi-step operations. Never produces code that contains any of the eight canonical anti-patterns.\nlitedbmodel API reference (use ONLY these — never invent methods):\n  Model.create(cols, opts?) — single INSERT.\n    opts: { returning, onConflict, onConflictIgnore, onConflictUpdate }\n  Model.createMany(rows, opts?) — batch INSERT with same opts.\n  Model.find(conds, opts?) — SELECT.\n    opts: { order, limit, offset, forUpdate }\n  Model.findOne(conds, opts?) — single-row SELECT.\n  Model.findById(pkeyResult) — find by PkeyResult object.\n  Model.update(conds, vals, opts?) — UPDATE matching rows.\n  Model.updateMany(rows, opts?) — bulk UPDATE.\n    opts: { keyColumns }\n  Model.delete(conds, opts?) — DELETE matching rows.\n  Model.query(sql, params) — raw SQL returning typed model instances.\n  DBModel.execute(sql) — raw SQL for DDL/maintenance (no model instances).\n  DBModel.transaction(fn, opts?) — transaction wrapper.\n    opts: { retryOnError, retryLimit }\n  SKIP — exclude a condition or column dynamically.\n  sql tagged template — operator-based conditions.\n    Column references: sql`${Model.col} > ${val}`\n    IS NULL: sql`${Model.col} IS NULL`\n    IN: [sql`${Model.col} IN (?)`, [...values]]\n  forUpdate: true — SELECT FOR UPDATE (must be inside a transaction).\n  onConflict + onConflictUpdate — upsert.\n    Target column(s) must have UNIQUE or PRIMARY KEY constraint.\n  onConflict + onConflictIgnore — insert-or-ignore.\n    Same constraint requirement.\n  Column references are symbol-based: Model.column_name (not strings).\n  Conditions are type-safe tuples: [[Model.col, value], ...].",
  mode: "read-write",
  dispatch_only: false,
  can_read_artifacts: [],
  can_write_artifacts: [],
  can_execute_tools: [],
  can_invoke_agents: [],
  can_return_handoffs: [
  "litedbmodel-implement-result"
],
  responsibilities: [
  "Step 1: Use Glob to find model definition files matching the models glob pattern in the user request. Read each matched file to extract model classes, column definitions, and table names.",
  "Step 2: Read the target file specified in the user request. Examine its current content. If it contains only stubs, TODOs, or empty class bodies, you MUST write the full implementation.",
  "Step 3: Use Edit or Write tool to add the implementation directly to the target file. You MUST actually modify the file on disk. Never claim 'implementation is already present' unless the function body you just read contains real business logic — not stubs or TODOs.",
  "Apply correct patterns proactively — never generate loop-inside-create, delete-reinsert, bare non-idempotent create, or N+1 patterns.",
  "Surface design concerns (missing UNIQUE constraints, missing transactions, ambiguous schema) as findings with severity info or warning."
],
  constraints: [
  "Only reference model classes and columns that exist in the project's model definition files.",
  "Never invent or fabricate litedbmodel API methods not listed in the API reference above.",
  "Keep all generated TypeScript strict-mode compliant.",
  "If the model/schema context is insufficient, list the missing information explicitly and stop."
],
  rules: [
  {
    "id": "R-IMPL-001",
    "description": "Never generate a for/while loop body that calls Model.create(). Always use Model.createMany() for batch writes.",
    "severity": "mandatory"
  },
  {
    "id": "R-IMPL-002",
    "description": "Idempotent single-row writes must pass onConflict with either onConflictIgnore: true or onConflictUpdate: [...] to Model.create(). Bare Model.create() that can throw on duplicate keys is forbidden.",
    "severity": "mandatory"
  },
  {
    "id": "R-IMPL-003",
    "description": "Multi-step read-modify-write sequences must be wrapped in DBModel.transaction() to prevent partial updates.",
    "severity": "mandatory"
  },
  {
    "id": "R-IMPL-004",
    "description": "Any read that is immediately followed by a conditional write in a concurrent context must use findOne/find with forUpdate: true inside a transaction.",
    "severity": "mandatory"
  },
  {
    "id": "R-IMPL-005",
    "description": "Whenever onConflict is generated, add a code comment noting that the referenced column(s) must have a UNIQUE or PRIMARY KEY constraint.",
    "severity": "mandatory"
  }
],
  escalation_criteria: [
  {
    "condition": "The feature description is too ambiguous to be mapped to any model class in the project.",
    "action": "stop_and_report"
  },
  {
    "condition": "No model definitions or SQL schema found in the project and the feature requires specific column knowledge.",
    "action": "stop_and_report"
  }
],
} as const;

export const agentRegistry: Record<string, AgentContract> = {
  "litedbmodel-auditor": litedbmodelAuditor,
  "litedbmodel-implementer": litedbmodelImplementer,
} as const;

export type AgentId = keyof typeof agentRegistry;
